import { CheckCircle2, Clock3, FileCheck2, Hash, Link2, ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const checks = [
  { icon: CheckCircle2, title: 'recipient.check.photo' },
  { icon: Clock3, title: 'recipient.check.time' },
  { icon: Hash, title: 'recipient.check.hash' },
  { icon: ShieldCheck, title: 'recipient.check.server' },
];

export function RecipientViewSection() {
  const { t } = useI18n();

  return (
    <section className="section recipient-section" id="recipient-view">
      <div className="recipient-copy">
        <p className="eyebrow">{t('recipient.eyebrow')}</p>
        <h2>{t('recipient.title')}</h2>
        <p>{t('recipient.text')}</p>
        <div className="recipient-link-card">
          <Link2 size={22} />
          <div>
            <strong>{t('recipient.link.title')}</strong>
            <span>{t('recipient.link.text')}</span>
          </div>
        </div>
        <div className="recipient-check-grid">
          {checks.map((item) => {
            const Icon = item.icon;
            return (
              <div className="recipient-check" key={item.title}>
                <Icon size={20} />
                <span>{t(item.title)}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="recipient-visual">
        <img
          className="app-screen"
          src="/assets/app-screens/proof-result.jpg"
          alt={t('recipient.visualAlt')}
          width="655"
          height="1280"
          loading="lazy"
        />
        <div className="recipient-proof-card">
          <FileCheck2 size={22} />
          <strong>{t('recipient.card.title')}</strong>
          <span>{t('recipient.card.text')}</span>
        </div>
      </div>
    </section>
  );
}
